import { render } from "./ChatRoomInfo.vue?vue&type=template&id=c88b043c"
import script from "./ChatRoomInfo.vue?vue&type=script&lang=js"
export * from "./ChatRoomInfo.vue?vue&type=script&lang=js"
script.render = render

export default script